import React, {useRef} from 'react';
import {observer} from "mobx-react";
import {SaveGameButtonContainerBox} from "./save-game-button-container.box";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {withServices} from "../../../../react-hooks/with-services";
import {DotLottiePlayer} from "../../../lottie-player/dot-lottie-player.component";
import {DotLottieCommonPlayer, PlayerEvents} from "@dotlottie/react-player";

export interface SaveGameButtonComponentWithServicesProps extends ComponentServicesPick<'games' | 'notifications' | 'theme'> {
    gameType: number;
}

const ComponentBody :React.FC<SaveGameButtonComponentWithServicesProps> = observer((props) => {

    const [isSaved, setIsSaved] = React.useState(props.games.savedGameTypes.indexOf(props.gameType) >= 0);
    let firstReadyComplete: boolean = false;

    let lottieRef = useRef<DotLottieCommonPlayer>(null);

    const toggleSaveGame = (): void => {
        if (!isSaved) {
            lottieRef.current.play();
            props.games.saveGame(props.gameType);
        } else {
            lottieRef.current.reset();
            props.games.removeSavedGame(props.gameType);
        }

        setIsSaved((wasSaved) => !wasSaved);
    };

    const onLottieEvent = (event) => {

        if (event === PlayerEvents.Ready && !firstReadyComplete && isSaved) {
            lottieRef.current.seek(60);
            firstReadyComplete = true;
        }

        if (event === PlayerEvents.Complete) {
            props.notifications.showGameSavedNotification();
        }
    };

    return (
        <SaveGameButtonContainerBox onClick={toggleSaveGame}>
            <DotLottiePlayer
                style={{width: "45px", height: "45px"}}
                ref={lottieRef}
                src={props.theme.currentTheme.images.lottieAnimation.saveGameBookmark.toString()}
                onEvent={onLottieEvent}
            />
                <span>
                    {props.games.generateTimesSavedCounterForGame(props.gameType) + Number(isSaved)}
                </span>
        </SaveGameButtonContainerBox>
    );
});

export const SaveGameButtonComponent = withServices(ComponentBody, ["games", 'notifications', "theme"]);